/**
 * JS mirror of Ppk2\Profile\Contact\ContactRules (src/Contact/ContactRules.php). Keep in sync.
 * The server always re-checks.
 */
export const KEY = 'ppk2-profile.lib.contact.';
export const TYPES_RU = ['telegram', 'vk', 'ok', 'max'];
export const TYPES_OTHER = ['telegram', 'discord', 'facebook', 'whatsapp'];
export const VISIBILITY = ['everyone', 'members', 'club', 'nobody'];
export const DEFAULT_VISIBILITY = {
  max: 'nobody',
  whatsapp: 'nobody'
};
export const MAX_LENGTH = 100;
export const CHANNELS = ['site', 'email', 'telegram'];
// «Ответы в моих темах» / «Упоминания через @» removed: Flarum's own rows newPost / userMentioned cover them.
export const EVENTS = {
  messages: [true, true, true],
  // «Новые турниры» = every new tournament on the portal (old key club_tournaments, renamed by the server)
  new_tournaments: [true, false, true],
  tournament_reminder: [true, false, true],
  host_open: [true, false, true],
  portal_news: [true, true, false]
};

/** Tab «Оповещения»: group «Турниры» (shown first); the rest (messages) goes to group «Форум». */
export const TOURNAMENT_EVENTS = ['new_tournaments', 'tournament_reminder', 'host_open', 'portal_news'];
export function typesFor(country) {
  return country === 'RU' ? TYPES_RU : TYPES_OTHER;
}
export function defaultVisibility(type) {
  return DEFAULT_VISIBILITY[type] || 'members';
}

/** [cleaned value | null, error key | null] — same rules as the server. */
export function normalize(type, value) {
  // eslint-disable-next-line no-control-regex
  const v = (value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim();
  if (!v) return [null, null];
  if (v.length > MAX_LENGTH) return [null, 'too_long'];
  const noScheme = v.replace(/^(https?:\/\/)?(www\.|m\.)?/i, '');
  let h;
  switch (type) {
    case 'telegram':
      h = noScheme.replace(/^(t\.me|telegram\.me)\//i, '').replace(/^@+/, '');
      return /^[A-Za-z][A-Za-z0-9_]{4,31}$/.test(h) ? ['@' + h, null] : [null, 'telegram'];
    case 'vk':
      h = noScheme.replace(/^vk\.(com|ru)\//i, '');
      return /^[A-Za-z0-9_.]{2,64}$/.test(h) ? ['vk.com/' + h, null] : [null, 'vk'];
    case 'ok':
      h = noScheme.replace(/^ok\.ru\//i, '');
      return /^[A-Za-z0-9_.-]+(\/[A-Za-z0-9_.-]+)*$/.test(h) && h.length >= 2 && h.length <= 64 ? ['ok.ru/' + h, null] : [null, 'ok'];
    case 'facebook':
      h = noScheme.replace(/^(facebook\.com|fb\.com)\//i, '');
      return /^([A-Za-z0-9.]{5,50}|profile\.php\?id=[0-9]{5,20})$/.test(h) ? ['facebook.com/' + h, null] : [null, 'facebook'];
    case 'discord':
      return /^[A-Za-z0-9_.]{2,32}(#[0-9]{4})?$/.test(v) ? [v, null] : [null, 'discord'];
    case 'max':
    case 'whatsapp':
      {
        if (!/^\+[0-9 ()-]+$/.test(v)) return [null, 'phone'];
        const digits = v.replace(/[^0-9]/g, '');
        return digits.length >= 7 && digits.length <= 15 ? [v.replace(/\s+/g, ' '), null] : [null, 'phone'];
      }
  }
  return [null, 'invalid'];
}
flarum.reg.add('ppk2-profile', 'forum/utils/contactRules', { KEY: KEY,TYPES_RU: TYPES_RU,TYPES_OTHER: TYPES_OTHER,VISIBILITY: VISIBILITY,DEFAULT_VISIBILITY: DEFAULT_VISIBILITY,MAX_LENGTH: MAX_LENGTH,CHANNELS: CHANNELS,EVENTS: EVENTS,TOURNAMENT_EVENTS: TOURNAMENT_EVENTS,typesFor: typesFor,defaultVisibility: defaultVisibility,normalize: normalize, });